<template>
    <div>
            <!-- 약속처방 신청 -->
            <div class="title">
                <h2>약속처방 신청</h2>
            </div>                           
            <article class="view">
                <!-- 탕제 신청  -->
                <div class="tab_contents" >
  
                    <div class="lay_left" ref="leftRef">
                        <div class="table_list">
                            <table class="list no_view">
                                <thead>
                                    <tr>
                                        <th>처방분류</th>
                                        <th>급여구분</th>
                                        <th>처방일자</th>
                                        <th>처방기관</th>
                                        <th>처방의</th>
                                        <th>조제의뢰처</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><span>{{application.prescribe_type_nm}}</span></td>
                                        <td><span>비급여</span></td>
                                        <td><span>{{getCurrentDate()}}</span></td>
                                        <td><span>{{application.clinic_nm}}</span></td>
                                        <td><span>{{application.doctor_nm}}</span></td>
                                        <td><span>코끼리 원외탕전</span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- 환자 정보 -->
                        <div class="table_list">
                            <h3 class="tb_title">환자</h3>
                            <table class="write">
                                <colgroup>
                                    <col width="200">
                                    <col width="*">
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th><span>환자 정보</span></th>
                                        <td v-if="!isUserSelect">
                                            <button
                                                class="btn btn_md btn_darkbrown"
                                                @click="fn_click_search_petient()"
                                            >
                                                검색
                                            </button>
                                        </td>
                                        <td v-else>
                                            <div class="reset">
                                                    <!-- <button class="link"
                                                    @click="isShow.patient = !isShow.patient"> -->
                                                     <button class="link">
                                                    <p>{{patientInfo}}</p>
                                                </button>
                                                <button
                                                    class="btn btn_md btn_darkbrown btn_outline"
                                                    @click="resetDataPatient"
                                                >
                                                    환자초기화
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>처방 메모</th>
                                        <td><textarea v-model="application.prescribe_note" class="form_control"></textarea></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- 처방전 -->
                        <div class="table_list">
                            <h3 class="tb_title">처방전</h3>
                            <table class="write">
                                <colgroup>
                                    <col width="200">
                                    <col width="*">
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th><span class="emp">처방명</span></th>
                                        <td>
                                            <div class="form_inline w100">
                                                {{application.prescribe_nm}}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th><span>약속상품타입</span></th>
                                        <td>{{ application.promiseGoodsTypeNm}}</td>
                                    </tr>
                                    <tr>
                                        <th><span>판매 단위</span></th>
                                        <td>{{itemInfo.item_quantity}} {{promiseGoods.prepare_unit_nm}} <span v-if="application.order_quantity > 1">× {{ application.order_quantity }}</span></td>
                                    </tr>
                                    <tr>
                                        <th><span>판매 가격</span></th>
                                        <td>{{fn_comma_won(itemInfo.item_price)}} <span v-if="application.order_quantity > 1">× {{ application.order_quantity }}</span></td>
                                    </tr>
                                    <tr>
                                        <th><span>사전처방 잔여수령</span></th>
                                        <td>{{prescriptInfo.prescript_quantity - prescriptInfo.use_quantity}}</td>
                                    </tr>
                                    <tr>
                                        <th><span>구매수량</span></th>
                                        <td>
                                            <div class="form_spin" >
                                                <b-form-spinbutton  v-model="application.order_quantity" min="1" max="1000" @change="fn_change_total_price"></b-form-spinbutton>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="application.promiseGoodsType == 'gjd'">
                                        <th><span>복용법</span></th>
                                        <td>
                                            <div class="form_select">
                                                <b-form-select v-model="application.howtake_attach_yn">
                                                  <b-form-select-option value="N"
                                                  >미첨부</b-form-select-option
                                                  >
                                                <b-form-select-option value="Y"
                                                    >첨부</b-form-select-option
                                                >
                                                </b-form-select>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="application.promiseGoodsType == 'gjd'">
                                        <th><span>사향인증서</span></th>
                                        <td>
                                            <div class="form_select">
                                                <b-form-select v-model="application.musk_certificate_attach_yn" >
                                                  <b-form-select-option value="N"
                                                  >미첨부</b-form-select-option
                                                  >
                                                <b-form-select-option value="Y"
                                                    >첨부</b-form-select-option
                                                >
                                                </b-form-select>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="application.promiseGoodsType == 'gjd'">
                                        <th><span class="emp">10환 상자셋트 여부</span></th>
                                        <td>
                                            <div class="form_select">
                                                <b-form-select v-model="application.gjd_set_yn" @change="fn_change_set_yn">
                                                  <b-form-select-option value="N"
                                                  >선택안함</b-form-select-option
                                                  >
                                                  <b-form-select-option value="Y"
                                                    >포함</b-form-select-option
                                                  >
                                                </b-form-select>
                                                <span class="ml10" v-if="application.gjd_set_yn === 'Y'">[가격 : {{fn_comma_won(9000)}}원]</span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="application.promiseGoodsType == 'gjd'">
                                      <th><span class="emp">공진단 종이가방</span></th>
                                      <td>
                                        <div class="form_select">
                                          <b-form-select v-model="application.gjd_gift_bag_yn" @change="fn_product_count">
                                            <b-form-select-option value="N"
                                            >선택안함</b-form-select-option
                                            >
                                            <b-form-select-option value="Y"
                                            >포함</b-form-select-option
                                            >
                                          </b-form-select>
                                          <span class="ml10" v-if="application.gjd_gift_bag_yn === 'Y'">[가격 : {{fn_comma_won(900)}}원]</span>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr v-if="application.promiseGoodsType == 'gjd'">
                                        <th><span>10환 상자셋트</span></th>
                                        <td>
                                            <img 
                                                src="@/assets/img/layout/gjdSet.jpg" 
                                                alt=""
                                                class="w100"
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-if="application.promiseGoodsType != 'gjd'" class="table_list">
                            <table class="write">
                                <colgroup>
                                    <col width="200">
                                    <col width="30%">
                                    <col width="200">
                                    <col width="30%">
                                </colgroup>
                                <tbody>                               
                                    <tr>
                                        <th><span>포장</span></th>
                                        <td colspan="3">
                                            <div class="img_list">
                                                <div 
                                                    v-for="(item, index) in wrapperImgList" 
                                                    :key="index"
                                                    @click="fn_select_wrapper_img(item, index)"
                                                    @mouseenter="(evt) => viewBoxHandler(evt, item, 'wrapper')"
                                                    @mouseleave="viewWrapper = {}"
                                                    :class="{ on:selectWrapperImgIdx === index }"
                                                >
                                                    <img :src="'/file/getImgFile/' + item.wrapper_file_id" alt="">
                                                    <p>{{ item.wrapper_nm }}</p>
                                                </div>
                                                <div class="preview" 
                                                    v-if="viewWrapper.wrapper_file_id"
                                                    :style="`left: ${viewPositionX}px;`"
                                                >
                                                    <img :src="'/file/getImgFile/' + viewWrapper.wrapper_file_id" alt="">
                                                    <p>{{ viewWrapper.wrapper_nm }}</p>
                                                </div>
                                            </div> 
                                        </td>
                                    </tr>

                                    <tr>
                                        <th><span>박스</span></th>
                                        <td colspan="3">
                                            <div class="img_list">
                                                <div 
                                                    v-for="(item, index) in boxImgList" 
                                                    :key="index"
                                                    @click="fn_select_box_img(item, index)"
                                                    @mouseenter="(evt) => viewBoxHandler(evt, item, 'box')"
                                                    @mouseleave="viewBox = {}"
                                                    :class="{ on:selectBoxImgIdx === index }"
                                                >
                                                    <img :src="'/file/getImgFile/' + item.wrapper_file_id" alt="">
                                                    <p>{{ item.wrapper_nm }}</p>
                                                    <p>개당 {{ fn_comma_won(item.wrapper_sale_prc) }} 원</p>
                                                </div>
                                                <div class="preview" 
                                                    v-if="viewBox.wrapper_file_id"
                                                    :style="`left: ${viewPositionX}px;`"
                                                >
                                                    <img :src="'/file/getImgFile/' + viewBox.wrapper_file_id" alt="">
                                                    <p>{{ viewBox.wrapper_nm }}</p>
                                                    
                                                </div> 
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- 포장요구사항 -->
                        <div class="table_list">
                            <table class="write">
                                <colgroup>
                                    <col width="200">
                                    <col width="30%">
                                    <col width="200">
                                    <col width="30%">
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th><span>요구사항</span></th>
                                        <td colspan="3">
                                            <textarea name="" id="" class="form_control" placeholder="입력해주세요." v-model="application.wrapperReq" ></textarea>                                            
                                        </td>
                                    </tr>                                    
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="lay_right fix">
                        <div>
                            <div class="search" v-show="isShow.patient">
                                <div class="table_list">
                                    <div class="tabs">
                                        <button
                                            class="tb_title"
                                            v-for="(tab, idx) in tabMenuNames.patient" :key="idx"
                                            @click="fn_click_tab(idx)"
                                            :class="{ on:tabIndices.patient === idx }"
                                        >
                                            {{ tab }}
                                        </button>
                                        <button class="btn btn_md btn_brown ab-button" v-b-modal.petientWriteModal>
                                            <b-icon icon="person-plus-fill" class="mr10"></b-icon>
                                            등록
                                        </button>
                                    </div>
                                    <!-- 탕제신청 - #환자정보 -->
                                    <table class="write" v-show="tabIndices.patient === 0">
                                        <colgroup>
                                            <col width="100">
                                        </colgroup>
                                        <tbody v-if="selectPetientInfo.patient_chart_no ==  null">
                                            <tr>
                                                <td><span>환자가 선택되지 않았습니다.</span></td>                                            
                                            </tr>
                                        </tbody>
                                        <tbody v-else>
                                            <tr>
                                                <th><span>차트 번호</span></th>
                                                <td><span>{{ selectPetientInfo.patient_chart_no }}</span></td>
                                            </tr>
                                            <tr>
                                                <th><span>이름</span></th>
                                                <td><span>{{ selectPetientInfo.patient_nm }}</span></td>
                                            </tr>
                                            <tr>
                                                <th><span>성별</span></th>
                                                <td><span>{{ selectPetientInfo.patient_gender_nm }}</span></td>
                                            </tr>
                                            <tr>
                                                <th><span>나이</span></th>
                                                <td><span>{{ selectPetientInfo.patient_age }}세</span></td>
                                            </tr>
                                            <tr>
                                                <th><span>최근처방일</span></th>
                                                <td><span>{{ selectPetientInfo.last_prescribe_dt }}</span></td>
                                            </tr>
                                            <tr>
                                                <th><span>연락처</span></th>
                                                <td><span>{{ formatPhoneNumber(selectPetientInfo.patient_tel_num) }}</span></td>
                                            </tr>
                                            <tr>
                                                <th><span>주소</span></th>
                                                <td><span>{{ selectPetientInfo.patient_addr }} {{selectPetientInfo.patient_addr_dtl}}</span></td>
                                            </tr>
                                            <!-- <tr>
                                                <th><span>환자 메모</span></th>
                                                <td><span>{{ selectPetientInfo.patient_note }}</span></td>
                                            </tr> -->
                                        </tbody>
                                    </table>
                                    <div v-show="tabIndices.patient === 1">
                                        <!-- 환자검색 - #환자검색  -->
                                        <div class="list">                                        
                                            <ul class="search_filter">
                                                <li>
                                                    <p>환자명</p>
                                                    <input type="text" ref="inputPatientNm" placeholder="환자명을(를) 입력하세요" class="form_control" v-model="searchPatient.searchPatientNm" @change="fn_patient_page_init" @keyup.enter="fn_search_patient">
                                                    <button class="btn btn_md btn_outline" @click="fn_search_patient">검색</button>
                                                </li>
                                            </ul>
                                            <table class="list">
                                                <colgroup>
                                                    <col width="100">
                                                </colgroup>
                                                <thead>
                                                    <tr>
                                                        <th>차트</th>
                                                        <th>환자명</th>
                                                        <th>성별/나이</th>
                                                        <th>최근처방일</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-if="patientList.length == 0">
                                                        <td colspan="5"><span>데이터가 없습니다.</span></td>
                                                    </tr>
                                                <tr
                                                    v-for="(item, index) in patientList"
                                                    :key="index"
                                                    @click="fn_choose_patient(item)"
                                                >
                                                    <td><span>{{ item.patient_chart_no }}</span></td>
                                                    <td><span>{{ item.patient_nm }}</span></td>
                                                    <td><span>{{ item.patient_gender_nm }}/{{ item.patient_age }}</span></td>
                                                    <td><span>{{ item.last_prescribe_dt }}</span></td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            <PetientPagination :pageInfo=searchPatient.pageInfo @clickPage="fn_move_patientPage" v-show="searchPatient.PatientPageShow"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="search">
                                <div class="table_list">
                                    <div class="title_sm pt10 pb10">
                                        <h3 class="tb_title">배송 정보</h3>
                                    </div>
                                    
                                    <table class="write">
                                        <colgroup>
                                            <col width="30%">
                                            <col width="70%">
                                        </colgroup>
                                        <tbody>
                                            <tr>
                                                <th>발송 모드</th>
                                                <td>
                                                    <div class="form_select">
                                                        <b-form-select v-model="application.deliveryType" class="w100" @change="fn_change_delivery_type">
                                                            <b-form-select-option value="TTC">탕전실 > 한의원</b-form-select-option>
                                                            <b-form-select-option value="CTP">한의원 > 환자</b-form-select-option>
                                                            <b-form-select-option value="TTP">탕전실 > 환자</b-form-select-option>
                                                            <b-form-select-option value="TTT">탕전실 직접수령</b-form-select-option>
                                                            <b-form-select-option value="ETC">직접입력</b-form-select-option>
                                                        </b-form-select>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="table_list">
                                    <div class="title_sm pt10 pb10">
                                        <h3 class="tb_title">보내는 사람</h3>
                                    </div>
                                    <table class="write">
                                        <colgroup>
                                            <col width="30%">
                                            <col width="70%">
                                        </colgroup>
                                        <tbody>
                                            <tr>
                                                <th>발신인</th>
                                                <td><input type="text" class="form_control" placeholder="입력해주세요" v-model="application.send_nm"></td>
                                            </tr>                                    
                                            <tr>
                                                <th>연락처</th>
                                                <td><input type="text" class="form_control" placeholder="입력해주세요" v-model="application.send_tel_num"></td>
                                            </tr>
<!--                                            <tr>-->
<!--                                                <th>휴대폰</th>-->
<!--                                                <td><input type="text" class="form_control" placeholder="입력해주세요" v-model="application.send_phone_num"></td>-->
<!--                                            </tr>       -->
                                            <tr>
                                                <th>우편번호</th>
                                                <td>
                                                    <div class="form_inline">
                                                        <input type="text" class="form_control" placeholder="입력해주세요" v-model="application.send_post_no">
                                                        <button class="btn btn_md btn_darkbrown" @click="fn_postSearch('send')">검색</button>                                                
                                                    </div>
                                                </td>
                                            </tr>   
                                            <tr>
                                                <th>주소</th>
                                                <td><input type="text" class="form_control" placeholder="입력해주세요" v-model="application.send_addr"></td>
                                            </tr>
                                            <tr>
                                                <th>상세주소</th>
                                                <td><input type="text" class="form_control" placeholder="입력해주세요" v-model="application.send_addr_dtl"></td>
                                            </tr>                                       
                                        </tbody>
                                    </table>
                                </div>
                                <div class="table_list">
                                    <div class="title_sm pt10 pb10">
                                        <h3 class="tb_title">받는 사람</h3>
                                    </div>
                                    <table class="write">
                                        <colgroup>
                                            <col width="30%">
                                            <col width="70%">
                                        </colgroup>
                                        <tbody>
                                            <tr>
                                                <th>수신인</th>
                                                <td><input type="text" class="form_control" placeholder="입력해주세요" v-model="application.receive_nm" ></td>
                                            </tr>                                    
                                            <tr>
                                                <th>연락처</th>
                                                <td><input type="text" class="form_control" placeholder="입력해주세요" v-model="application.receive_tel_num"></td>
                                            </tr>
                                            <tr>    
                                                <th>휴대폰</th>
                                                <td><input type="text" class="form_control" placeholder="입력해주세요" v-model="application.receive_phone_num"></td>
                                            </tr>       
                                            <tr>
                                                <th>우편번호</th>
                                                <td>
                                                    <div class="form_inline">
                                                        <input type="text" class="form_control" placeholder="입력해주세요" v-model="application.receive_post_no">
                                                        <button class="btn btn_md btn_darkbrown" @click="fn_postSearch('recive')">검색</button>                                                
                                                    </div>
                                                </td>
                                            </tr>   
                                            <tr>
                                                <th>주소</th>
                                                <td><input type="text" class="form_control" placeholder="입력해주세요" v-model="application.receive_addr"></td>
                                            </tr>
                                            <tr>    
                                                <th>상세주소</th>
                                                <td><input type="text" class="form_control" placeholder="입력해주세요" v-model="application.receive_addr_dtl"></td>
                                            </tr>                                       
                                        </tbody>
                                    </table>
                                </div>
                                
                                <div class="table_list">
                                    <div class="title_sm pt10 pb10">
                                        <h3 class="tb_title">기타 정보</h3>
                                    </div>
                                    <table class="write">
                                        <colgroup>
                                            <col width="30%">
                                            <col width="70%">
                                        </colgroup>
                                        <tbody>
                                            <tr>
                                                <th><span>배송메모</span></th>
                                                <td>
                                                    <textarea name="" id="" class="form_control" style="height:100px" placeholder="입력해주세요." v-model="application.deliveryMemo"></textarea>                                            
                                                </td>
                                            </tr>                                    
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="fix" ref="test_scroll" style="margin-bottom: 120px;" :style="{'transform' : 'translateY('+ tranformPx +'px)'}">
                            <div class="search">
                                <div class="table_list">
                                    <div class="detail">
                                        <div class="title_sm pt0">
                                            <h3 class="tb_title">예상 결제 비용</h3>
                                        </div>
                                        <table class="write">
                                            <colgroup>
                                                <col width="100">
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th>상품비</th>
                                                    <td>{{itemInfo.item_quantity}} {{promiseGoods.prepare_unit_nm}} × {{application.order_quantity}} </td>
                                                    <td class="ar"><span>{{ fn_comma_won(application.total_price) }}원</span></td>
                                                </tr>
                                                <tr>
                                                  <th>제품비</th>
                                                  <td>10환상자/종이가방</td>
                                                  <td class="ar"><span>{{ fn_comma_won(application.total_product_price) }}원</span></td>
                                                </tr>
                                                <tr>
                                                    <th>배송비</th>
                                                    <td></td>
                                                    <td class="ar"><span>{{ fn_comma_won(application.total_delivery_price) }}원</span></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table class="write bn">
                                            <colgroup>
                                                <col width="130">
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th>총 결제 비용</th>
                                                    <td class="ar">
                                                        <span>{{ fn_comma_won(application.total_price  + application.total_delivery_price + application.total_product_price) }}원</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div> 


                    </div>
                    <div class="bottom_box">
                        <div class="btn_box">
                            <button class="btn btn_md btn_brown" @click="fn_application_reg" v-if="clinicDoctorClass == 'C'">처방전 접수</button>
                        </div>
                    </div> 
                </div>
            </article>
            <petientWriteModal
                :title="'환자 간편 등록'"
                @callback="fn_patientWtrite_callback"
            />
            <AlertModal
                :id="'alert'"
                :text="showAlertMsg" 
                :btnRight="'확인'" 
                :oneBtn="false"
                :isShow="showAlert"
                :className="'btn_brown'"
                v-on:update:showSetting="fn_showSet"
            />
            <!-- <AlertModal 
                :id="'confirm'"
                :text="alertMsg" 
                :btnLeft="'취소'" 
                :btnRight="'확인'" 
                :oneBtn="true"
                :isShow="initAlertShow"
                :className="'btn_brown'"
                @callback="fn_alert_close"
            />     -->
    </div>               
</template>

<script>
    import PetientPagination from "@/components/AdminPagination.vue"
    import axios from 'axios'
    import petientWriteModal from '@/modal/user/petientWriteModal.vue'
    
    import commonUtil from "@/mixin/commonUtil";
    import Datepicker from '@/components/Datepicker.vue'
    import { nextTick } from 'vue'
    import AlertModal from "@/modal/common/alertModal.vue"
    import alertutill from "@/mixin/alertModalUtill";

    import { 
        format,
        count,
        time,
        temperature,
        forbidden
    } from '@/data/user/takingData'

    import {
        patientInfoData,                      
        beforeReceiptData,
        searchData 
    } from "@/data/user/ApplicationData"



    export default {
        name : 'ApplictionHerbMedicine',
        mixins: [commonUtil,alertutill],
        components: {
            PetientPagination,  //환자검색 페이징 - #환자검색
            petientWriteModal,
           
            Datepicker,
            AlertModal            
        },
        watch: {
            searchItem (item) {
                if (item === '') {
                    this.searchAutoBox = false
                }
            },
        },
        created(){
            
            let clinicDoctorId = this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];

            console.log("@@@@@ clinicDoctorId : "+clinicDoctorId);

            if(clinicDoctorId == null || clinicDoctorId == ''){
                this.$router.push({ name: 'UserLogin'}); 
            }

            this.promiseGoods = this.$store.getters['promiseGoodsInfo/getPromiseGoods'];            //약속상품  
            this.prescriptInfo = this.$store.getters['promiseGoodsInfo/getPrescriptInfo'];          //사전처방수량  
            this.itemInfo = this.$store.getters['promiseGoodsInfo/getItemInfo'];                    //구성상품  

            //this.application.doctorNm = this.$store.getters['clinicDoctorInfo/getDoctorNm']                        
            this.application.doctor_nm = this.$store.getters['clinicDoctorInfo/getDoctorNm'];
            this.application.clinic_doctor_id = this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];
            this.application.clinic_nm = this.$store.getters['clinicDoctorInfo/getClinicNm'];
            this.application.clinic_tel = this.$store.getters['clinicDoctorInfo/getClinicTelNum']; 
            this.application.clinic_addr = this.$store.getters['clinicDoctorInfo/getClinicAddr'];               //처방기관
            this.application.clinic_addr_detail =this.$store.getters['clinicDoctorInfo/getClinicAddrDtl'];        
            this.clinicDoctorClass = this.$store.getters['clinicDoctorInfo/getClinicDoctorClass']; 
            
            this.application.promiseGoodsCd = this.promiseGoods.promise_goods_cd;               //약속처방코드
            this.application.prescribe_nm = this.promiseGoods.promise_goods_nm;                  //약속처방명 (처방명)
            this.application.promiseGoodsType = this.promiseGoods.promise_goods_type;          //약속처방타입코드
            this.application.promiseGoodsTypeNm = this.promiseGoods.promise_goods_type_nm;        //약속처방타입명
            
            //구성상품명을 처방명으로
            this.application.prescribe_nm = this.itemInfo.item_nm;
            this.application.goods_seq = this.itemInfo.goods_seq;
            this.application.item_price = this.itemInfo.item_price;
            this.application.item_quantity = this.itemInfo.item_quantity;               //상품수량

            if(this.application.promiseGoodsType != 'gjd'){
                this.fn_search_wrapperImg();
                this.fn_search_boxImg();
            }
        },
        mounted () {
            //this.leftArea = this.$refs['leftRef'].offsetHeight
            //20250402- 환자검색 계속노출
            this.isShow.patient     = true;
            this.tabIndices.patient = 1;
            this.fn_search_patient();

            //총가격 계산
            this.fn_change_total_price();

            //배송정보처리
            this.application.deliveryType = "CTP";
            this.fn_change_delivery_type();

            // 스크롤 이벤트 적용
            //document.addEventListener('scroll', this.scrollEvents);

        },
        unmounted() {
            //스크롤 이벤트 제거
            //document.removeEventListener('scroll', this.scrollEvents);
        },
        methods: {
            // scrollEvents(){
            //     // console.log("window.scrollY : %o",window.scrollY);
            //     // console.log("sShow : %o",this.isShow.totalParice );

            //     if(this.isShow.totalParice && window.scrollY > 1260){
            //         //여기까지
            //         this.div_place = this.$refs.test_scroll.getBoundingClientRect();

            //         console.log("div hight :"+ this.div_place.bottom);

            //         this.tranformPx = 916 - Math.round(div_place.bottom);

            //         console.log("tranformPx:"+ Number(this.tranformPx));

            //     }
                

            // },
            
            /*********************************************************************
             * 환자검색 - #환자검색
             *********************************************************************/
            //환자정보 초기화
            resetDataPatient () {

                this.alertMsg = "환자 정보를 초기화 하시겠습니까?"
                this.initAlertShow = true;
                this.initInfo = 'patient'
            },

            //환자검색버튼 클릭
            fn_click_search_petient(){
                // if(this.isShow.patient == false){
                //     this.isShow.patient = !this.isShow.patient;
                // }
                this.tabIndices.patient = 1;
                nextTick(() => {
                    this.$refs.inputPatientNm.focus();
                })
                
                this.fn_search_patient();
            },
            fn_patient_page_init(){
                this.searchPatient.pageInfo.page = 1;
            },
            // 환자검색 
            async fn_search_patient(){

                this.searchPatient.searchClinicDoctorId = this.application.clinic_doctor_id;

                console.log("@@@@ searchPatient clinic_doctor_id : %o",this.application.clinic_doctor_id);
                console.log("@@@@ searchPatient : %o",this.searchPatient);
                await axios
                    .post("/api/user/petient/getPetientList", this.searchPatient)
                    .then((res) => {
                        console.log("@@@@ 환자검색 res : %o",res);
                        this.patientList = res.data.petientList;

                        console.log("@@@@ 환자검색 patientList : %o",this.patientList);
                        
                        this.searchPatient.pageInfo.totPage = res.data.totCnt;
                        
                        if(this.searchPatient.pageInfo.totPage> 0){
                            this.searchPatient.PatientPageShow = true;                          
                        }else{
                            this.searchPatient.PatientPageShow = false;
                        }                        

                        console.log("@@@@ searchPatient : %o",this.searchPatient);

                    })
                    .catch((err) => console.log(err));
             },
             //환자검색 페이징처리
             fn_move_patientPage(page){
                this.searchPatient.pageInfo.page = page;
                this.fn_search_patient();
             },
             fn_choose_patient(patientInfo){

                this.isUserSelect = true;
                
                //선택된 환자정보
                this.selectPetientInfo = patientInfo;

                this.selectPetientInfo.clinic_doctor_id = this.application.clinic_doctor_id;
                //처방내역 페이징을 위한 처리
                this.selectPetientInfo.pageInfo = {
                      page : 1,
                      pageSize : 5,
                      totPage : 0
                    }
                this.selectPetientInfo.prescribePageShow = false;
                    

                //화면에 뿌리는 문구
                this.patientInfo = patientInfo.patient_nm + '('+patientInfo.patient_gender_nm+'/'+patientInfo.patient_age+') '+patientInfo.patient_chart_no

                //처방 환자 정보 입력
                this.application.patient_seq = patientInfo.patient_seq;
                this.application.patient_name = patientInfo.patient_nm;

                this.tabIndices.patient = 0;

                //발송모드가 한의원->환자, 탕전실->환자 인경우
                if(this.application.deliveryType == "CTP" || this.application.deliveryType == "TTP"){
                    this.application.receive_nm = this.selectPetientInfo.patient_nm;
                    this.application.receive_tel_num = "";
                    this.application.receive_phone_num = this.selectPetientInfo.patient_tel_num;
                    this.application.receive_post_no = this.selectPetientInfo.patient_post_no;
                    this.application.receive_addr = this.selectPetientInfo.patient_addr;
                    this.application.receive_addr_dtl = this.selectPetientInfo.patient_addr_dtl;
                }

             },
            //환자 tab
            fn_click_tab(idx){
                this.tabIndices.patient = idx;                
            },

            //환자등록 저장후 콜백
            async fn_patientWtrite_callback(patientSeq){

                await this.fn_search_patient();
                this.patientList.forEach((item,index)=>{
                    if(item.patient_seq == patientSeq){
                        this.fn_choose_patient(item);
                        return;
                    }
                })                        
            },

            fn_change_set_yn(){
              if(this.application.gjd_set_yn === 'Y'){
                this.application.howtake_attach_yn = "Y";
                this.application.musk_certificate_attach_yn = "Y";
              }else{
                this.application.howtake_attach_yn = "N";
                this.application.musk_certificate_attach_yn = "N";
              }

              this.fn_product_count();
            },
            /************************************************************************
             * 비용계산
             ************************************************************************/     
            fn_change_total_price(){
                let total_price = this.itemInfo.item_price * this.application.order_quantity;
                this.application.total_price = total_price;
            },
            /************************************************************************
             * 발송
             ************************************************************************/ 
            fn_change_delivery_type(){
                
                this.application.total_delivery_price = 4000;

                if(this.application.deliveryType == "TTC"){
                    this.application.send_nm = this.$store.getters['tangjunInfo/getTangjunNm'];
                    this.application.send_tel_num = this.$store.getters['tangjunInfo/getTangjunTelNum'];
                    //this.application.send_phone_num = this.$store.getters['tangjunInfo/getTangjunPhoneNum'];
                    this.application.send_post_no = this.$store.getters['tangjunInfo/getTangjunPost'];
                    this.application.send_addr = this.$store.getters['tangjunInfo/getTangjunAddr'];
                    this.application.send_addr_dtl = this.$store.getters['tangjunInfo/getTangjunAddrDtl'];

                    this.application.receive_nm = this.$store.getters['clinicDoctorInfo/getClinicNm'];
                    this.application.receive_tel_num = this.$store.getters['clinicDoctorInfo/getDoctorTelNum'];
                    this.application.receive_phone_num = this.$store.getters['clinicDoctorInfo/getDoctorPhoneNum'];
                    this.application.receive_post_no= this.$store.getters['clinicDoctorInfo/getClinicPostNo'];
                    this.application.receive_addr = this.$store.getters['clinicDoctorInfo/getClinicAddr'];
                    this.application.receive_addr_dtl = this.$store.getters['clinicDoctorInfo/getClinicAddrDtl'];

                }else if(this.application.deliveryType == "CTP"){
                    //의사명에서 한의원 명으로 변경 (20260117)
                    //의사전화번호에서 한의원 전화번호로 변경 (20260129)
                    this.application.send_nm = this.$store.getters['clinicDoctorInfo/getClinicNm'];
                    this.application.send_tel_num= this.$store.getters['clinicDoctorInfo/getClinicTelNum'];
                    //this.application.send_phone_num= this.$store.getters['clinicDoctorInfo/getDoctorPhoneNum'];
                    this.application.send_post_no = this.$store.getters['clinicDoctorInfo/getClinicPostNo'];
                    this.application.send_addr = this.$store.getters['clinicDoctorInfo/getClinicAddr'];
                    this.application.send_addr_dtl = this.$store.getters['clinicDoctorInfo/getClinicAddrDtl'];

                    this.application.receive_nm = this.selectPetientInfo.patient_nm;
                    this.application.receive_tel_num = "";
                    this.application.receive_phone_num = this.selectPetientInfo.patient_tel_num;
                    this.application.receive_post_no = this.selectPetientInfo.patient_post_no;
                    this.application.receive_addr = this.selectPetientInfo.patient_addr;
                    this.application.receive_addr_dtl = this.selectPetientInfo.patient_addr_dtl;
                }else if(this.application.deliveryType == "TTP"){
                    this.application.send_nm = this.$store.getters['tangjunInfo/getTangjunNm'];
                    this.application.send_tel_num = this.$store.getters['tangjunInfo/getTangjunTelNum'];
                    //this.application.send_phone_num = this.$store.getters['tangjunInfo/getTangjunPhoneNum'];
                    this.application.send_post_no = this.$store.getters['tangjunInfo/getTangjunPost'];
                    this.application.send_addr = this.$store.getters['tangjunInfo/getTangjunAddr'];
                    this.application.send_addr_dtl = this.$store.getters['tangjunInfo/getTangjunAddrDtl'];

                    this.application.receive_nm = this.selectPetientInfo.patient_nm;
                    this.application.receive_tel_num = "";
                    this.application.receive_phone_num = this.selectPetientInfo.patient_tel_num;
                    this.application.receive_post_no = this.selectPetientInfo.patient_post_no;
                    this.application.receive_addr = this.selectPetientInfo.patient_addr;
                    this.application.receive_addr_dtl = this.selectPetientInfo.patient_addr_dtl;
                }else if(this.application.deliveryType == "TTT"){
                    this.application.send_nm = this.$store.getters['tangjunInfo/getTangjunNm'];
                    this.application.send_tel_num = this.$store.getters['tangjunInfo/getTangjunTelNum'];
                    //this.application.send_phone_num = this.$store.getters['tangjunInfo/getTangjunPhoneNum'];
                    this.application.send_post_no = this.$store.getters['tangjunInfo/getTangjunPost'];
                    this.application.send_addr = this.$store.getters['tangjunInfo/getTangjunAddr'];
                    this.application.send_addr_dtl = this.$store.getters['tangjunInfo/getTangjunAddrDtl'];

                    this.application.receive_nm = this.$store.getters['tangjunInfo/getTangjunNm'];
                    this.application.receive_tel_num =  this.$store.getters['tangjunInfo/getTangjunTelNum'];
                    this.application.receive_phone_num = this.$store.getters['tangjunInfo/getTangjunPhoneNum'];
                    this.application.receive_post_no = this.$store.getters['tangjunInfo/getTangjunPost'];
                    this.application.receive_addr = this.$store.getters['tangjunInfo/getTangjunAddr'];
                    this.application.receive_addr_dtl = this.$store.getters['tangjunInfo/getTangjunAddrDtl'];

                    //배송비 차감
                    this.application.total_delivery_price = 0;
                }else{
                    this.application.send_nm = "";
                    this.application.send_tel_num= "";
                    this.application.send_phone_num= "";
                    this.application.send_post_no = "";
                    this.application.send_addr = "";
                    this.application.send_addr_dtl = "";

                    this.application.receive_nm = ""; 
                    this.application.receive_tel_num = "";
                    this.application.receive_phone_num = "";
                    this.application.receive_post_no = "";
                    this.application.receive_addr = "";
                    this.application.receive_addr_dtl = "";
                }
            },
            //다음주소 정보 가져오기
            callBackAddr(call,postInfo){
                
                if(call == "send"){
                    this.application.send_post_no = postInfo.zonecode;
                    this.application.send_addr = postInfo.roadAddress;
                    this.application.send_addrDtl = "";    
                }else if(call == "recive"){
                    this.application.receive_post_no = postInfo.zonecode;
                    this.application.receive_addr = postInfo.roadAddress;
                    this.application.receive_addr_dtl = "";
                }                
            },
            /**********************************************************
             * 탕제신청 확인
             **********************************************************/    
            fn_medicineList_info(){
                let medicineInfo = "";

                for(let i = 0; i < this.application.prescribe_medicine.length; i++){
                    if(i == 0){
                        medicineInfo = this.application.prescribe_medicine[i].med_hrb_nm+" "+this.application.prescribe_medicine[i].chupCnt;
                    }else{
                        medicineInfo = medicineInfo + "," + this.application.prescribe_medicine[i].med_hrb_nm+" "+this.application.prescribe_medicine[i].chupCnt;
                    }
                }

                //console.log("@@@@@@@@@@@@탕제신청확인 약제정보 111: "+medicineInfo);

                this.med_list = medicineInfo;                
            },


            fn_alert_close(type){
                
                console.log("@@@@ type : "+type);
                 this.initAlertShow = false;  

                if(type == 'ok'){
                    if(this.initInfo == "patient"){
                        this.isUserSelect = false           //환자선택여부
                        //this.isShow.patient = false         //환자검색
                        this.isDetail = false
                        this.gridSelect.patient = null
                        this.gridSelect.patientPrescribe = null
                        this.tabIndices.patient = 1

                        this.selectPetientInfo = {};
                    }
                }
            },
            
            /**********************************************************
             * 발송요청
             **********************************************************/ 
            //다음단계
            fn_application_reg(){
                
                if(this.application.prescribe_nm == ''){
                    let msg = "처방명을 입력하세요";
                    this.fn_open_alert(msg); 
                    
                    return;
                }else if(this.application.patient_seq == ''){
                    let msg = "환자를 입력하세요";
                    this.fn_open_alert(msg); 
                    return;
                }

                let preRegCnt = this.prescriptInfo.prescript_quantity - this.prescriptInfo.use_quantity
                if(this.itemInfo.item_quantity * this.application.order_quantity > preRegCnt){
                    alert("주문수량보다 사전처방 수량이 적습니다.");
                    return;
                }

                console.log("@@@@  약속상품 req : %o",this.application);

                axios
                    .post("/api/user/appliction/regPromisGooodsApply", this.application)
                    .then((res) => {
                        console.log("@@@@  탕제신청 저장 res : %o",res);
                        alert("저장되었습니다.");

                        this.$router.push("/mypage/orderCheckoutList");
                        

                    })
                    .catch((err) => console.log(err));
            },
            // 포장 정보 가져오기
            fn_search_wrapperImg(){
                axios
                    .post("/api/user/appliction/searchWrapperImg")
                    .then((res) => {
                        console.log("@@@@ res : %o",res);
                        this.wrapperImgList = res.data.wrapperImgList;

                        console.log("@@@@ wrapperImgList : %o",this.wrapperImgList);

                        this.application.wrapperImgInfo = this.wrapperImgList[0];

                    })
                    .catch((err) => console.log(err));
            },
            fn_search_boxImg(){
                axios
                    .post("/api/user/appliction/searchBoxImg")
                    .then((res) => {
                        this.boxImgList = res.data.boxImgList;
                        this.application.boxImgInfo = this.boxImgList[0];
                    })
                    .catch((err) => console.log(err));
            },
             //제품비용 계산
            fn_product_count(){

                let setPrice = 0;
                let giftBagPrice = 0;

                if(this.application.gjd_set_yn === 'Y'){
                  setPrice = 9000;
                }

                if(this.application.gjd_gift_bag_yn === 'Y'){
                  giftBagPrice = 900;
                }


               this.application.total_product_price = setPrice + giftBagPrice;

            },
            // 포장 이미지 선택
            fn_select_wrapper_img(item, index){
                this.selectWrapperImgIdx = index;
                this.application.wrapperImgInfo = item;

                //상비약 포장일 경우
                if(item.wrapper_cd == "W000000005"){
                    for(let i = 0; i < this.boxImgList.length ; i++){
                        let wrapperCd = this.boxImgList[i].wrapper_cd
                        //상비약 상자 선택 처리 
                        if(wrapperCd == "W000000006"){
                            this.selectBoxImgIdx = i;
                            this.application.boxImgInfo = this.boxImgList[i];
                        }
                    }
                }else{
                    //상비약 상자인 경우 (W000000008)
                    if(this.application.boxImgInfo.wrapper_cd == "W000000006"){
                            this.selectBoxImgIdx = 0;
                            this.application.boxImgInfo = this.boxImgList[0];
                    }
                    
                }

                this.fn_product_count();

            },
            //박스 이미지 선택
            fn_select_box_img(item, index){
                /**
                 * 상비약 포장일 경우 상비약 상자만 선택 가능
                 * 상비약 포장이 아닌경우 상비약 상자 선택 불가
                 */
                if(this.application.wrapperImgInfo.wrapper_cd != "W000000005"){                            
                    if(item.wrapper_cd == "W000000006"){
                        let msg = "상비약 포장일때만 선택 가능합니다";
                        this.fn_open_alert(msg); 
                    }else{
                        this.selectBoxImgIdx = index;
                        this.application.boxImgInfo = item;
                    }                
                }else{
                    if(item.wrapper_cd != "W000000006"){
                        let msg = "상비약 포장인 경우 상비약 박스만 가능합니다";
                        this.fn_open_alert(msg); 
                    }else{
                        this.selectBoxImgIdx = index;
                        this.application.boxImgInfo = item;
                    }
                }

                this.fn_product_count();
            },

        },
        data () {
            return {

                prescriptInfo : {},                 //사전처방 정보
                promiseGoods : {},                  //약속상품 정보
                itemInfo : {},                      //구성상품 정보

                leftArea : 0,
                viewPositionX: 0,
                tranformPx : 0,
                div_hight : 0,
                clinicDoctorClass : '',
                
                
                application : {
                    prescribe_type : 'P',           //처방분류
                    prescribe_type_nm : '약속처방',  //처방분류명

                    clinic_doctor_id : '',          //한의원 한의사ID
                    doctor_nm : '',                 //의사명
                    clinic_nm : '',                 //처방기관
                    clinic_tel : '',                //처방기관
                    clinic_addr : '',               //처방기관
                    clinic_addr_detail : '',        //처방기관
                    
                    patient_seq : '',               //환자SEQ
                    patient_name : '',               //환자명
                    prescribe_note : '',            //처방메모
                    prescribe_nm : '',              //처방명
                    prescribe_source : '',          //출전명

                    goods_seq : '',                  //약속상품 구성 seq


                    total_etc_price : 0,            //총기타비용
                    total_product_price : 0,        //제품비
                    total_delivery_price : 4000,       //총배송비용
                    total_price : 0,                //총가격
                    
                    mark_yn : 'Y',                  //마킹여부
                  
                    instructions : '',              //조제지시
                    deliveryType : 'CTP',           //배송방법 
                    send_nm : "",                   //보내는 사람명
                    send_tel_num: "",               //보내는 사람 전화번호
                    send_phone_num: "",             //보내는 사람 핸드폰 번호
                    send_post_no : "",              //보내는 사람 우편번호
                    send_addr : "",                 //보내는 사람 주소
                    send_addrDtl : "",              //보내는 사람 주소상세
                    receive_nm : "",                //받는 사람 명
                    receive_tel_num : "",           //받는 사람 전화번호
                    receive_phone_num : "",         //받는 사람 핸드폰번호
                    receive_post_no: "",            //받는 사람 우편번호
                    receive_addr : "",              //받는 사람 주소
                    receive_addr_dtl : "",           //받는 사람 주소상세   
                    deliveryMemo : '',              //배송메모
                    wrapperReq : '',                //포장요구사항

                    promiseGoodsCd : '',            //약속처방코드
                    promiseGoodsType : '',          //약속처방타입코드
                    promiseGoodsTypeNm : '',        //약속처방타입명

                    order_quantity : 1,

                    item_price : 0,
                    item_quantity : 0,
                    howtake_attach_yn : 'N',
                    musk_certificate_attach_yn : 'N',
                    gjd_set_yn : 'N',                      //10환 상자셋틍
                    gjd_gift_bag_yn : 'N',                 //공진당 종이가방

                    wrapperImgInfo : {},            //선택된 포장방식이미지
                    boxImgInfo : {},                //선택된 박스이미지 
                              
                },

                currentMenu: 0,            //현재텝 

                //환자검색 데이터
                searchPatient : {
                    searchClinicDoctorId : '',
                    searchPatientNm : '',
                    pageInfo : {
                      page : 1,
                      pageSize : 5,
                      totPage : 0
                    },
                    PatientPageShow : false                    
                },
                patientInfo : '',          //화면표출문구
                selectPetientInfo :{},     //선택된 환자정보
                packlist : [],             //팩수   
                patientList : [],          //환자리스트 
                packCount : [],               
                

                //박스, 포장 정보 추가 (20251206)
                viewBox: {},
                viewWrapper :{},
                wrapperImgList : [],              // 포장 이미지 리스트
                boxImgList : [],                  //박스 이미지 리스트
                selectWrapperImgIdx : 0,
                selectBoxImgIdx :0,    

                tabIdx: 0,
                tabSelect: null,
                isUserSelect: false,
                
                searchItem: undefined,
                lastStep: false,
                tabMenuNames: {
                    patient: ['환자 정보', '검색']             
                },
                
                isShow: {
                    patient: false,
                },
                isDetail: false,
                isSearchDetail : {
                    medicine: false,
                    selfDictionary: false,
                    dictionary: false,
                    beforeReceipt: false,
                },
                tabIndices: {
                    patient: 0,
                    medicine: 0,
                    filterTab: 0,
                    filterTab2: 0,
                    filterTab3: 0,
                },
                gridSelect: {
                    patient: 0,
                    patientPrescribe: 0,
                    medicine: 0,
                    selfDictionary: 0,
                    dictionary: 0,
                    beforeReceipt: 0,
                },
                
                
                rightPatientInfoHead: [
                    { head: '최근처방일' },
                    { head: '구분' },
                    { head: '처방명' },
                    { head: '처방의' },
                    { head: '반영' },
                ],         
                // rightSelfDictionaryHead: [
                //     { head: '처방명' },
                //     { head: '출전' },
                //     { head: '등록자' },
                //     { head: '반영' },
                // ],                      

                
                patientInfoData: patientInfoData,
                searchData: searchData,
                

                beforeReceiptData: beforeReceiptData,
                selectedBoxList1 : [
                    { path : require('@/assets/img/layout/intro14.jpg'), title : '파우치 1' },
                    { path : require('@/assets/img/layout/intro14.jpg'), title : '파우치 2' },
                    { path : require('@/assets/img/layout/intro14.jpg'), title : '파우치 3' }
                ],

                //복용법관련 데이터
                howTake: [
                    { th : '복용법', require: true, data: format , selected: '', label: '', etcMsg: '', mode : 'upload'},
                    { th : '복용 횟수', require: false, data: count , selected: '', label: '', etcMsg: '' },
                    { th : '복용 시간', require: false, data: time , selected: '', label: '', etcMsg: '' },
                    { th : '복용 온도', require: false , data: temperature, selected: '', label: '', etcMsg: '' },
                    { th : '금할 음식', require: true, data: forbidden , selected: [], label: '', etcMsg: '' , mode: 'select'}
                ],
                alertMsg : '',
                initAlertShow : false,
                initInfo : '',  

            }

        },        
    }
</script>